import { render, staticRenderFns } from "./AnswerTypeCheckbox.vue?vue&type=template&id=a1b4998c&scoped=true"
import script from "./AnswerTypeCheckbox.vue?vue&type=script&lang=js"
export * from "./AnswerTypeCheckbox.vue?vue&type=script&lang=js"
import style0 from "./AnswerTypeCheckbox.vue?vue&type=style&index=0&id=a1b4998c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b4998c",
  null
  
)

export default component.exports